export const CSE_CX = "a5ec407c10a9646d2";
export const CSE_FALLBACK_URL = `https://cse.google.com/cse?cx=${CSE_CX}`;

export const CATEGORIES = [
    { label: "Music", query: "influential music artists albums and history" },
    { label: "Film", query: "greatest films and iconic directors of all time" },
    { label: "Culture", query: "world culture traditions and art movements" },
    { label: "Tech", query: "latest technology breakthroughs and innovation" },
    { label: "Life", query: "life advice wellbeing and everyday curiosity" },
];

export const SURPRISE_TOPICS = [
    "the history of jazz",
    "how black holes actually work",
    "the origins of hip hop culture",
    "the most beautiful architecture in the world",
    "the science behind why we dream",
    "legendary film directors and their signature style",
    "the future of human space travel",
    "iconic street food around the world",
    "the psychology of curiosity",
    "the design story behind legendary sneakers",
    "lost cities rediscovered by archaeologists",
    "how the northern lights are created",
];

export function randomSurprise() {
    return SURPRISE_TOPICS[Math.floor(Math.random() * SURPRISE_TOPICS.length)];
}
